// extracted by mini-css-extract-plugin
export default {"AgentLinkView":"AgentLinkView__NUjZPWRXADKL","AgentLinkView_avatar":"AgentLinkView_avatar__EDKBwFNTOz9B","AgentLinkView_name":"AgentLinkView_name___0zxdfGCQuEz"};